/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
/**
* CSS Custom Properties
*
* These properties can be overridden using the component's tag as selector.
*
* @prop --calcite-ui-icon-color: [Deprecated] Use `--calcite-icon-color`. Specifies the component's color. Defaults to current color.
* @prop --calcite-icon-color: Specifies the component's color. Defaults to current color.
*/
:host {
  display: inline-flex;
  color: var(--calcite-icon-color, var(--calcite-ui-icon-color, currentColor));
}

:host([scale=s]) {
  inline-size: 16px;
  block-size: 16px;
  min-inline-size: 16px;
  min-block-size: 16px;
}

:host([scale=m]) {
  inline-size: 24px;
  block-size: 24px;
  min-inline-size: 24px;
  min-block-size: 24px;
}

:host([scale=l]) {
  inline-size: 32px;
  block-size: 32px;
  min-inline-size: 32px;
  min-block-size: 32px;
}

.flip-rtl {
  transform: scaleX(-1);
}

.svg {
  display: block;
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}